<template>
  <div>
    <div class="container lg" :class="s.wrap">
      <spacer :y="20" />
      <p class="text-center">MITTをご利用いただきありがとうございます！</p>
      <spacer :y="2" />
      <div class="d-flex justify-content-center">
        <basic-btn tag="a" link="/login">ログイン</basic-btn>
        <spacer :x="2" />
        <basic-btn tag="a" link="/about">アプリドライバー登録</basic-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BasicBtn,
  Spacer,
} from '@/components/parts';

export default {
  name: 'non-user-home',
  components: {
    BasicBtn,
    Spacer,
  },
  data() {},
  created() {
    this.$router.push('/login');
  },
  computed: { },
  methods: {},
};
</script>

<style lang="scss" module="s">
.wrap {
  margin-top: var(--header-height);
}
</style>
